module.exports = __webpack_public_path__ + "img/Media-Destruction.8b892c2e.png";